export enum AnalyticsWidgetTabsEnum {
    ALL = 'all',
    USERS = 'users',
    PRODUCT = 'product',
    BEST = 'best',
    PROMOTIONS = 'promotions',
    PRICE = 'price',
}
